export const parseProgress = (value?: string): { done: number; total: number } | null => {
  if (!value) return null;
  const match = /^(\d+)\s*\/\s*(\d+)$/.exec(value);
  if (!match) return null;
  return { done: Number(match[1]), total: Number(match[2]) };
};
